import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useCallback } from 'react';
import { IMenuProduct } from '~/types/products';
import { formatPrice } from '~/utils/formatter';
import { productUtils } from '~/utils/productUtils';
import Quantity from '~/view/components/Controls/Quantity/Quantity';
import { useCheckoutStoreContext } from '~/view/screens/CheckoutScreen/context';
import './style.scss';
import { getWalletCurrency } from '~/utils/helpers';
import { appStore } from '~/mobx/appStore';

interface IProps {
  product: IMenuProduct;
  productError: string | undefined;
}

export const OrderCartProductFooter: FC<IProps> = memo(
  observer((props: IProps): ReactElement => {
    const { product, productError } = props;

    const { store: checkoutStore } = useCheckoutStoreContext();

    const changeQuantity = useCallback(
      (quantity: number) => {
        checkoutStore.updateProduct({ ...props.product, quantity });
      },
      [props.product]
    );

    const currency = checkoutStore.dependencies.branch.currency?.currency_code;
    const price = formatPrice(productUtils.calculateMenuProductPrice(props.product), currency);

    return (
      <div className="order-cart-product-footer">
        <p className="order-cart-product-footer__price text-nowrap">{price}</p>

        <Quantity
          value={product.quantity}
          onChange={changeQuantity}
          minusButtonDisabled={Boolean(productError)}
          plusButtonDisabled={Boolean(productError)}
          small
        />
      </div>
    );
  })
);
